import { render, staticRenderFns } from "./PreventivaPanel.vue?vue&type=template&id=266402ae&scoped=true&"
import script from "./PreventivaPanel.vue?vue&type=script&lang=js&"
export * from "./PreventivaPanel.vue?vue&type=script&lang=js&"
import style0 from "./PreventivaPanel.vue?vue&type=style&index=0&id=266402ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266402ae",
  null
  
)

export default component.exports